export class Beta {
  desktopApp: boolean;
  zoom: boolean;
  multiLanguageMode: boolean;

  constructor(beta?: Beta) {
    if (undefined === beta) {
      this.getDefaultValues();
    } else {
      this.desktopApp = beta.desktopApp;
      this.zoom = beta.zoom;
      this.multiLanguageMode = beta.multiLanguageMode;
    }
  }

  getDefaultValues() {
    this.desktopApp = false;
    this.zoom = false;
    this.multiLanguageMode = false;
  }
}
